import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import PopupAPI from '../../apis/PopupAPI';
import ic_cam from '../../assets/ic_cam.png';
import { useDialog } from '../../dialog/DialogProvider';
import OneButtonAlertDialog from '../../dialog/OneButtonAlertDialog';
import './Modify_PopupManagement.scss';
interface FileParams {
    savedPath?: string;
}
const Modify_PopupManagement = () => {
    const { showDialog } = useDialog();
    const navigate = useNavigate();
    const npuUidS = sessionStorage.getItem('popupN');
    const [uploadFiles, setUploadFiles] = useState([] as File[]);
    const [previewImages, setPreviewImages] = useState<string[]>([]);
    const [textValue, setTextValue] = useState<string>('');
    const [popUseStatus, setPopUseStatus] = useState(true);
    const [deleteFileIds, setDeleteFileIds] = useState([] as number[]);
    const [imgNpfUid, setImgNpfUid] = useState<number>(0);
        const [targetUrl, setTargetUrl ] = useState<string>('');

    useEffect(() => {
        PopupAPI.getPopupDetail({
            npuUid: Number(npuUidS)
        }).then((res) => {

            setTextValue(res.title);
            setPopUseStatus(res.status === 'Y' ? true : false);
            if (res.fileList.length !== 0) {
                setImgNpfUid(res.fileList[0].npfUid);
                const files: File[] = [];
                const promises: Promise<any>[] = [];
                const promise = getFiles({
                    savedPath: res.fileList[0].savePath,
                }).then((data) => {
                    if (data) {
                        var startIndex = data.data.type.lastIndexOf('/');
                        var endIndex = data.data.type.lastIndexOf('.png');
                        var jpgEndIndex = data.data.type.lastIndexOf('.jpg');
                        const file = new File([data.data], res.fileList[0].fileName, {
                            type: 'image/png',
                        });
                        files.push(file);
                        const previewImage = `/api/attach/getFile?savedPath=${res.fileList[0].savePath}`;
                        setPreviewImages((prevImages) => [previewImage]);
                    }
                });
                promises.push(promise);
            }
        })
    }, [])

    const getFiles = (params: FileParams) => {
        return axios
            .get(`/api/attach/getFile`, {
                responseType: 'blob',
                params: params,
            })
            .then((res) => res as any);
    };

    // 사진 첨부
    const handleImageChange = (event: React.ChangeEvent<HTMLInputElement>, npfUid: number) => {
        if (npfUid) {
            if (!deleteFileIds.includes(npfUid)) {

                setDeleteFileIds((cur) => [...cur, npfUid]);
            }
        }
        const files = event.target.files;
        if (!files) return;
        const selectedImages = Array.from(files);
        // 미리보기 이미지 추가
        const imagesToSubmit = selectedImages.slice(0, 5);
        const newPreviewImages = imagesToSubmit.map((file) =>
            URL.createObjectURL(file)
        );
        setUploadFiles((prevImages) => [...selectedImages]);
        setPreviewImages((prevImages) => [...newPreviewImages]);
    };

    const handleTextValue = (text: string) => {
        setTextValue(text);
    }
    const handlePopupUseStatus = (status: boolean) => {
        if (status) {
            setPopUseStatus(true);
        } else {
            setPopUseStatus(false);
        }
    }

    // 첨부한 이미지 파일 x 버튼 누를시 삭제
    const handleRemovePreview = (index: number, npfUid: number) => {
        if (npfUid) {

            setDeleteFileIds((cur) => [...cur, npfUid]);
        }
        setPreviewImages((prevImages) => {
            const newImages = [...prevImages];
            newImages.splice(index, 1);
            return newImages;
        });
        if (!npfUid) {
            setUploadFiles((prevFiles) => {
                const newFiles = [...prevFiles];
                newFiles.splice(index, 1);
                return newFiles;
            });
        }
    };

    const handleUpdate = () => {

        if (uploadFiles.length == 0 && textValue == '') {
            const title = '팝업 관리';
            const message = '사진 또는 내용을 입력해주세요.';
            showDialog(OneButtonAlertDialog, { title, message });
            return;
        }

        PopupAPI.updatePopup({
            npuUid: Number(npuUidS),
            title: textValue === '' ? '' : textValue,
            status: popUseStatus ? 'Y' : 'N',
        }, uploadFiles, deleteFileIds, targetUrl)
            .then((res) => {
                if (res.data.type == 1) {

                    const title = '팝업 관리';
                    const message = '수정을 성공하였습니다.';
                    showDialog(OneButtonAlertDialog, {
                        title,
                        message,
                        handleDialogResult(result) {
                            if (result === 'ok') {
                                navigate('/popup_02/');
                                window.location.reload();
                            }
                        },
                    });
                } else {

                    const title = '팝업 관리';
                    const message = '수정을 실패하였습니다.';
                    showDialog(OneButtonAlertDialog, {
                        title,
                        message,
                    });
                }
            }).catch(() => {

                const title = '팝업 관리';
                const message = '수정을 실패하였습니다.';
                showDialog(OneButtonAlertDialog, {
                    title,
                    message,
                });
            })
    }
    const handleCancle = () => {
        navigate(-1);
    }
    return (
        <main className="Modify_PopupManagement">
            <h1 className="notext">전체 영역</h1>
            <nav id="lnb">
                <h2 className="notext">네비게이션 영역</h2>

                <div className="lnb_txt">
                    <h3 style={{ display: 'block', fontSize: '40px' }}>팝업 관리</h3>
                </div>
            </nav>
            <article id="container">
                <h2 className="notext">컨텐츠 영역</h2>
                {/* 해당 페이지의 시작입니다 */}
                <div id="content" className="comm_manage_wrap">
                    <div className='imgInput'>
                        <div>
                            {/* <input
                                type="file"
                                id="img"
                                accept="image/*"
                                onChange={handleImageChange}
                            /> */}
                            <div className="imgContainer">
                                <div className="imgBox">
                                    <input className="upload-photo" />
                                    <label htmlFor="img">
                                        <img src={ic_cam} alt="사진 첨부" />
                                        사진 첨부
                                        <span>(1장)</span>
                                    </label>
                                    <input
                                        type="file"
                                        id="img"
                                        accept="image/*"
                                        onChange={(e) => handleImageChange(e, Number(imgNpfUid))}
                                    />
                                </div>
                                <div className="imglistBox">
                                    <ul>
                                        {previewImages.map((imageUrl, index) => (
                                            <li key={index}>
                                                <img src={imageUrl} key={imageUrl} />
                                                <button
                                                    type="button"
                                                    onClick={() => handleRemovePreview(
                                                        index,
                                                        Number(imgNpfUid)
                                                    )}
                                                    className="btn-file-delet"
                                                />
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="cont-box">
                        <input
                                type="text"
                                // className="long"
                                placeholder="https://형식으로 작성해주세요."
                                value={targetUrl}
                                onChange={e => setTargetUrl(e.target.value)}
                            />
                            </div>
                        {/* 25년 5월 요청사항
                        <div>
                            <textarea
                                placeholder="내용을 입력하세요"
                                className='textBox'
                                defaultValue={''}
                                value={textValue}
                                onChange={(e) => handleTextValue(e.target.value)}
                                style={{ resize: 'none' }}
                            />
                        </div> */}
                        <div style={{ fontWeight: '600' }}>
                            <input
                                type="checkbox"
                                id='chek'
                                checked={popUseStatus}
                                onChange={(e) => handlePopupUseStatus(e.target.checked)}
                            />
                            팝업 사용 여부
                        </div>
                        <div className='buttonDiv'>
                            <button type='button' id="cancleButton" onClick={handleCancle}>취소</button>
                            {/* <button type='button' className={`insertButton ${uploadFiles.length == 0 ? '' : 'on'}`} onClick={handleUpdate}>수정</button> */}
                            <button type='button' className={`insertButton on`} onClick={handleUpdate}>수정</button>
                        </div>
                    </div>
                    <div className='preview'>
                        {previewImages.map((imageUrl, index) => (
                            <img className='previewImg' src={imageUrl} key={imageUrl} alt="" />
                        ))}
                        <div style={{ height: previewImages.length !== 0 ? '80px' : '600px' }}>{textValue && textValue.split("\n")
                            .map(
                                (
                                    item,
                                    index
                                ) => (
                                    <React.Fragment
                                        key={
                                            index
                                        }
                                    >
                                        {item}
                                        <br />
                                    </React.Fragment>
                                )
                            )}</div>
                    </div>
                </div>
                {/* 해당 페이지의 종료입니다 */}
            </article>
        </main>
    );
};

export default Modify_PopupManagement;